module.exports = __webpack_public_path__ + "img/green_heart.291991f0.png";